export { default as TRANSFERS } from './transferMessages';
export { default as ACTION_TYPES } from './actionTypes';
export { default as DEFAULTS } from './defaults';
export { default as CHAT_ICON_CONFIG } from './chatIcon';

export const DEVICE_PLATFORM_MAP = {
  WEBSDK: '5',
  ANDROIDSDK: '2',
  IOSSDK: '6',
};
